import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result, mappingResultError } from '@digibricks/domains';
import { REPORT_API } from '../data-sources';
import { REPORT_REPOSITORY } from '../../core';
export var ReportRepository = /*#__PURE__*/function () {
  function ReportRepository(reportApi) {
    _classCallCheck(this, ReportRepository);

    this.reportApi = reportApi;
  }

  _createClass(ReportRepository, [{
    key: "getGeneralInformationReport",
    value: function () {
      var _getGeneralInformationReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(assignmentId) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.reportApi.getGeneralInformationReport(assignmentId);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                response = responseOrError.getValue();
                return _context.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getGeneralInformationReport(_x) {
        return _getGeneralInformationReport.apply(this, arguments);
      }

      return getGeneralInformationReport;
    }()
  }, {
    key: "getQuestionReports",
    value: function () {
      var _getQuestionReports = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(assignmentId, sectionId, isBookmarked) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.reportApi.getQuestionReports(assignmentId, sectionId, isBookmarked);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                response = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getQuestionReports(_x2, _x3, _x4) {
        return _getQuestionReports.apply(this, arguments);
      }

      return getQuestionReports;
    }()
  }, {
    key: "updateQuestionReportBookmark",
    value: function () {
      var _updateQuestionReportBookmark = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(assignmentId, questionReportId) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.reportApi.updateQuestionReportBookmark(assignmentId, questionReportId);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateQuestionReportBookmark(_x5, _x6) {
        return _updateQuestionReportBookmark.apply(this, arguments);
      }

      return updateQuestionReportBookmark;
    }()
  }]);

  return ReportRepository;
}();
export var reportRepositoryProvider = {
  provide: REPORT_REPOSITORY,
  useFactory: function useFactory(reportApi) {
    return new ReportRepository(reportApi);
  },
  inject: [REPORT_API]
};